<template>
  <div class="contract-preview">
    <div class="header-actions">
      <el-button type="primary" @click="downloadPDF" :disabled="!renderedContent">下载PDF</el-button>
      <el-button @click="printContract" :disabled="!renderedContent">打印</el-button>
      <el-button @click="goBack">返回</el-button>
    </div>

    <div class="contract-content" id="contract-content" v-loading="loading">
      <div class="contract-paper" v-if="renderedContent" v-html="renderedContent"></div>
      <div v-else-if="!loading" class="no-content">
        <el-empty description="暂无合同内容" />
      </div>
    </div>
  </div>
</template>

<script>
import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'

export default {
  name: 'ContractPreview',
  data() {
    return {
      loading: false,
      renderedContent: '',
      orderUuid: '',
      templateName: '',
    }
  },
  methods: {
    loadContract() {
      this.loading = true
      this.$http.request('renderContract', {
        order_uuid: this.orderUuid,
      }).then(res => {
        this.loading = false
        if (res && res.data) {
          this.renderedContent = res.data.content
          this.templateName = res.data.template_name || ''
        } else {
          this.$message.error('获取合同内容失败')
        }
      }).catch(err => {
        this.loading = false
        const msg = err && err.message ? err.message : '获取合同内容失败'
        this.$message.error(msg)
      })
    },
    downloadPDF() {
      const element = document.getElementById('contract-content')
      const loading = this.$loading({
        lock: true,
        text: '正在生成PDF,请稍候...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })

      html2canvas(element, {
        scale: 2,
        useCORS: true,
        allowTaint: true
      }).then(canvas => {
        const contentWidth = canvas.width
        const contentHeight = canvas.height
        const imgData = canvas.toDataURL('image/jpeg', 0.98)

        const pdf = new jsPDF('p', 'mm', 'a4')
        const pageWidth = pdf.internal.pageSize.getWidth()
        const pageHeight = pdf.internal.pageSize.getHeight()

        const marginTop = 20
        const marginBottom = 20
        const marginLeftRight = 15

        const usableWidth = pageWidth - marginLeftRight * 2
        const usableHeight = pageHeight - marginTop - marginBottom

        const imgWidth = usableWidth * 0.9
        const imgHeight = (contentHeight * imgWidth) / contentWidth

        const startX = (pageWidth - imgWidth) / 2
        let positionY = marginTop
        let heightLeft = imgHeight

        pdf.addImage(imgData, 'JPEG', startX, positionY, imgWidth, imgHeight)
        heightLeft -= usableHeight

        while (heightLeft > 0) {
          pdf.addPage()
          positionY = heightLeft - imgHeight + marginTop
          pdf.addImage(imgData, 'JPEG', startX, positionY, imgWidth, imgHeight)
          heightLeft -= usableHeight
        }

        pdf.save(`旅游合同_${this.orderUuid}.pdf`)
        loading.close()
      }).catch(err => {
        console.error('PDF生成失败:', err)
        loading.close()
        this.$message.error('PDF生成失败，请重试')
      })
    },
    printContract() {
      window.print()
    },
    goBack() {
      window.close()
    }
  },
  mounted() {
    this.orderUuid = this.$route.query.orderUuid
    if (this.orderUuid) {
      this.loadContract()
    } else {
      this.$message.error('缺少订单号')
      setTimeout(() => {
        window.close()
      }, 1500)
    }
  }
}
</script>

<style scoped>
.contract-preview {
  padding: 20px;
  background: #f5f5f5;
  min-height: 100vh;
}

.header-actions {
  text-align: right;
  margin-bottom: 20px;
  padding: 15px;
  background: white;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.contract-content {
  max-width: 210mm;
  margin: 0 auto;
  background: white;
  padding: 12mm;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.15);
  page-break-inside: avoid;
  break-inside: avoid;
}

.contract-paper {
  font-size: 12px;
  line-height: 1.6;
  color: #333;
}

/* 让后端渲染的 HTML 中的表格和段落保持良好样式 */
.contract-paper :deep(table) {
  width: 100%;
  border-collapse: collapse;
  margin: 8px 0;
  page-break-inside: avoid;
  break-inside: avoid;
}

.contract-paper :deep(td),
.contract-paper :deep(th) {
  border: 1px solid #ddd;
  padding: 6px 10px;
  line-height: 1.5;
}

.contract-paper :deep(p) {
  margin: 0 0 6px 0;
}

.contract-paper :deep(h1),
.contract-paper :deep(h2),
.contract-paper :deep(h3) {
  page-break-after: avoid;
  break-after: avoid;
}

.no-content {
  padding: 60px 0;
  text-align: center;
}

/* 打印样式 */
@media print {
  .header-actions {
    display: none;
  }

  .contract-preview {
    padding: 0;
    background: white;
  }

  .contract-content {
    padding: 12mm;
    box-shadow: none;
    border: none;
    max-width: none;
  }

  .contract-paper :deep(div),
  .contract-paper :deep(table) {
    page-break-inside: avoid;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/contract/contract-preview.vue